<div id="angularRoot">
  <mat-tab-group ngClass.xs="social-tab-group-xs app-tabbar-fix" ngClass.gt-xs="social-tab-group-gt-xs" (selectChange)="focusChanged($event)">
    <mat-tab label="Mission Control" #tab1="">
      <bh-missioncontrol></bh-missioncontrol>
    </mat-tab>
    <mat-tab label="Sentiments" #tab2="">
      <bh-products [tabChange]="currentIndex"></bh-products>
    </mat-tab>
  </mat-tab-group>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/socialComponent/social.template.html